import { FormattedMessage, useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { useLocation } from 'react-router-dom-v5-compat';

import { config } from '@/config/config';
import { useBreakpoint } from '@/hooks/useBreakpoint';
import { VaultRole } from '@/modules/api/codegen';
import { Button, Icon, IconButton } from '@/modules/ui';
import { selectActiveVaultId, useVaults } from '@/modules/vaults';

import { useSaasCountReached } from '../../hooks/useSaasCountReached';
import * as felaRules from './AddSecretButton.rules';

export const AddSecretButton = () => {
    const history = useHistory();
    const { pathname, search } = useLocation();
    const { formatMessage } = useIntl();

    const { isError } = useSaasCountReached();

    const isMin768 = useBreakpoint('sm');

    const activeVaultId = useSelector(selectActiveVaultId);
    const { vaults } = useVaults();

    // Only a vault the user can edit is worth prefilling — saving into a view-only one is rejected.
    const canEditActiveVault = vaults.some(({ id, userRole }) => id === activeVaultId && userRole === VaultRole.editor);

    const openNewSecret = () => {
        history.push(config.routes.newSecret, { from: pathname + search, vaultId: canEditActiveVault ? activeVaultId : null });
    };

    if (isMin768) {
        return (
            <Button type='primary' icon={<Icon type='add' />} disabled={isError} size='large' onClick={openNewSecret}>
                <>
                    <FormattedMessage id='secret.add' />
                </>
            </Button>
        );
    }

    return (
        <IconButton
            type='primary'
            icon='add'
            disabled={isError}
            customStyle={felaRules.iconButtonContainer}
            aria-label={formatMessage({
                id: 'secret.list.add',
            })}
            onClick={openNewSecret}
        />
    );
};
